<app-header [signin]="isLoggedIn ? false : true"></app-header>

<div class="main-content-payment">
  <nav
    aria-label="breadcrumb"
    style="
      margin-top: 35px;
      left: 0;
      position: relative;
      width: 100%;
      margin-left: 60px;
    "
  >
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a routerLink="/page/dashboard" *ngIf="isLoggedIn"
          ><i class="icon text-info fa fa-home"></i
        ></a>
      </li>
      <li class="breadcrumb-item active" aria-current="page" *ngIf="isLoggedIn">
        {{ "Form.Renewlicense" | translate }}
      </li>
    </ol>
  </nav>
  <div class="intro-section">
    <h2>{{ "Form.THANK_YOU_TITLE" | translate }}</h2>
    <p>
      {{ "Form.THANK_YOU_TITLE" | translate }}
      {{ "Form.Login.ARCHITECTURE_INFO_MESSAGE" | translate }}
    </p>
    <div>
      <ul>
        <li>
          <strong>{{ "Form.Login.POINT1HEADING" | translate }}</strong>
          {{ "Form.Login.Point1" | translate }}
        </li>
        <li>
          <strong>{{ "Form.Login.POINT2HEADING" | translate }}</strong>
          {{ "Form.Login.Point2" | translate }}
        </li>
        <li>
          <strong>{{ "Form.Login.POINT3HEADING" | translate }}</strong>
          {{ "Form.Login.Point3" | translate }}
        </li>
        <li>
          <strong>{{ "Form.Login.POINT4HEADING" | translate }}</strong>
          {{ "Form.Login.Point4" | translate }}
        </li>
      </ul>
    </div>
  </div>

  <div class="payment-plans-title">
    <h2>{{ "Form.ChooseYourPlan" | translate }}</h2>
  </div>
  <div class="payment-plans-container">
    <div *ngIf="isLoading; else notLoading" class="loaderdata">
      <div class="spinner-border" role="status">
        <span class="sr-only">{{ "Form.Loading" | translate }}</span>
      </div>
    </div>
    <ng-template #notLoading>
      <div class="plan-card" *ngFor="let item of data">
        <h3>{{ item.displayName }}</h3>
        <p>{{ item.description }}</p>
        <p
          *ngIf="item.paymentFrequency == 'free'"
          style="font-weight: bold; color: grey"
        >
          &nbsp;
        </p>
        <p
          *ngIf="item.paymentFrequency != 'free'"
          style="font-weight: bold; color: grey"
        >
          <s> &dollar; {{ item.amount }}</s>
        </p>
        <p *ngIf="item.paymentFrequency == 'free'">
          <span style="font-size: large">&nbsp;</span><br /><span
            style="font-size: small"
            >&nbsp;</span
          >
        </p>
        <p *ngIf="item.paymentFrequency != 'free'">
          <span style="font-size: large; font-weight: bold">
            &dollar;{{ item.applicableAmount }}</span
          ><br /><span style="font-size: small">/Month/Project</span>
        </p>
        <button
          *ngIf="item.paymentFrequency == 'free'"
          style="background-color: #5b7690 !important"
          disabled
        >
          Choose
        </button>
        <button
          *ngIf="item.paymentFrequency != 'free'"
          (click)="selectPlan(item)"
        >
          Choose
        </button>
        <hr />
        <p
          style="text-align: left; margin-left: 5px"
          [innerHTML]="item.features"
        ></p>
      </div>
    </ng-template>
  </div>

  <div class="intro-section" style="margin-bottom: 80px">
    <div>
      <ul>
        <li>
          <strong>{{ "Form.Login.PaymentNote1" | translate }}</strong>
        </li>
        <li>
          <strong>{{ "Form.Login.PaymentNote2" | translate }}</strong>
        </li>
        <li>
          <strong>{{ "Form.Login.SessionPerrequest" | translate }}</strong>
        </li>
      </ul>
    </div>
  </div>
</div>
<app-footer></app-footer>
